import React from "react";
import { Handle, Position } from "@xyflow/react";
import "../../Product/index.css";
import SVGComponent from "../../../../../components/_utils/SVGComponent";
import ICONS from "../../../../../assets/Icons";

const ProductCard = React.memo(
  ({
    moduleName,
    productName,
    itemName,
    descriptions,
    moduleId,
    width,
    height,
    expanded,
    type,
    edges,
    logo,
  }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    const highlighted = edges?.some((val) => {
      return val?.target === moduleName;
    });
    return (
      <>
        <div
          className={`rounded-[10px] p-[20px] cursor-pointer product-card ${
            expanded ? "expand-enter" : ""
          }`}
          onMouseOver={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            width,
            height,
            background:
              isHovered && type === "core"
                ? "var(--product-core-hover)"
                : isHovered && type === "recommended"
                  ? "var(--product-recommended-hover)"
                  : isHovered && type === "enhancement"
                    ? "var(--product-enhancement-hover)"
                    : (highlighted || expanded) && type === "core"
                      ? "var(--product-core-active)"
                      : (highlighted || expanded) && type === "recommended"
                        ? "var(--product-recommended-active)"
                        : (highlighted || expanded) && type === "enhancement"
                          ? "var(--product-enhancement-active)"
                          : "",
            opacity: descriptions === null ? "0.5" : "1",
            border:
              (highlighted || expanded || isHovered) && type === "core"
                ? "var(--product-core-border)"
                : (highlighted || expanded || isHovered) &&
                    type === "recommended"
                  ? "var(--product-recommended-border)"
                  : (highlighted || expanded || isHovered) &&
                      type === "enhancement"
                    ? "var(--product-enhancement-border)"
                    : "1px solid var(--pending)",
            pointerEvents: descriptions === null ? "none" : "auto",
            transition: "background 0.3s ease-in-out",
          }}
        >
          {!expanded ? (
            <div className="flex flex-col gap-[20px]">
              <div className="bg-primary-bg w-[50px] h-[50px] rounded-full flex flex-row items-center justify-center overflow-hidden px-1">
                <SVGComponent
                  url={logo}
                  color="var(--text-primary)"
                />
              </div>
              <div className="flex flex-col gap-gap-sm opacity-100">
                <p className="text-text-primary text-font-lg font-normal">
                  {moduleName}
                </p>
                <p className="text-text-secondary text-font-md font-normal">
                  {productName}
                </p>
              </div>
              <div>
                <img
                  src={ICONS?.EXPAND}
                  alt="expand"
                  className="w-icon-md h-icon-md"
                />
              </div>
            </div>
          ) : (
            <div className="flex gap-gap-md justify-between  flex-col lg:flex-row h-full text-animate">
              <div className="flex flex-col gap-gap-md w-full lg:w-auto overflow-hidden">
                <div className="flex lg:items-center items-start flex-col lg:flex-row h-full lg:gap-gap-md gap-gap-sm">
                  <div className="bg-primary-bg w-[50px] h-[50px] rounded-full flex flex-row items-center justify-center overflow-hidden px-1">
                    <SVGComponent
                      url={logo}
                      color="var(--text-primary)"
                    />
                  </div>

                  <p className="text-text-primary lg:text-font-lg text-font-sm font-normal">
                    {moduleName}
                  </p>
                  <p className="text-text-secondary lg:text-[16px] text-font-xs font-normal">
                    {productName}
                  </p>
                </div>
                <div>
                  <ol className="list-disc list-inside pl-padding-md ">
                    {descriptions?.map((item, i) => (
                      <li
                        className="text-[12px] lg:text-font-md font-normal text-text-secondary"
                        key={i}
                      >
                        {item}
                      </li>
                    ))}
                  </ol>
                </div>
                <div className="hidden lg:block">
                  <img
                    src={ICONS?.EXPAND}
                    alt="collapse"
                    className="w-icon-md h-icon-md"
                  />
                </div>
              </div>
              <div className="lg:hidden block">
                <img
                  src={ICONS?.COLLAPSE}
                  alt="collapse"
                  className="w-icon-md h-icon-md"
                />
              </div>
            </div>
          )}
        </div>
        <Handle
          type="source"
          position={Position.Right}
          id="right"
          style={{
            width: 12,
            height: 12,
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            pointerEvents: "none",
          }}
        />
        <Handle
          type="target"
          position={Position.Left}
          id="left"
          style={{
            width: 12,
            height: 12,
            top: "50%",
            transform: "translateY(-50%)",
            background: "transparent",
            border: "none",
            pointerEvents: "none",
          }}
        />
      </>
    );
  },
);

export default ProductCard;
